// purpose: for custom popup for size chart, firmness, etc
// author: suresh.katiki
document.addEventListener("DOMContentLoaded", function() {
  // Close button & modal
  function setupModal(modal) {
    var span = modal.querySelector(".size-guide-close");

    if(span){
      span.onclick = function() { modal.style.display = "none"; }
    }

    window.addEventListener("click", function(event) {
      if (event.target == modal) { modal.style.display = "none"; }
    });
  }

  // Attach click to all size-guide links
  document.querySelectorAll(".plupopup").forEach(function(link) {
    link.addEventListener("click", function(event) {
      event.preventDefault(); // prevent default link action

      var targetId = link.getAttribute("data-target-id");
      var modal = document.getElementById("size-guide-modal");
      var allGuides = modal.querySelectorAll(".plupopup-content");

      // Hide all size-guides
      allGuides.forEach(el => el.style.display = "none");
      var noGuide = modal.querySelector("#plupopup-content-empty");
      if(noGuide) noGuide.style.display = "none";

      // Show the selected size-guide
      var selectedGuide = modal.querySelector('.plupopup-content[data-selector="'+ targetId +'"]');
      if(selectedGuide){
        selectedGuide.style.display = "block";
      } else if(noGuide){
        noGuide.style.display = "block";
      }

      // Open modal
      modal.style.display = "block";

      // Setup close buttons if not already
      setupModal(modal);
    });
  });
});